module.exports = {
        eva4Config: {
        token: {
            keycloak_url: 'https://keycloak-europe-admin.eva.bot/auth/realms/',
            org_name: 'IBERIA-EU',
            grant_type: 'client_credentials',
            client_id: process.env.EVA_CLIENT_ID || 'iberia-production',
            client_secret: process.env.EVA_CLIENT_SECRET || 'ySArz4Z3QdFeprGiLweq4LTW85Av9HjH'
        },
        conversation: {
            url: {
                instance: process.env.EVA_INSTANCE || 'europe-instance2',
                orgUUID: process.env.EVA_ORG_UUID || '098caa14-fdfc-4702-a995-e8b02022d21b',
                envUUID: process.env.EVA_ENV_UUID || '8a7c7855-5cc1-4d65-a08d-53523bbffc27',
                botUUID: process.env.EVA_BOT_UUID || '92abb587-6f10-44a6-ac8d-40565f4747b7',
                channelUUID: process.env.EVA_CHANNEL_UUID || 'f5ffb40d-9d25-4f5a-b359-e6070b28fa42',
            },
            headers: {
                "Content-Type": 'application/json',
                "API-KEY": process.env.EVA_API_KEY || '704508ad-7162-11ed-b9a6-4201ac1e0129',
                "LOCALE": 'es-ES',
                "OS": 'Windows'
            }
        }
    },
    liveAgentConfig: {
        chatAPIEndpoint: process.env.LA_URI || "https://europe-west3-dex-bot-iberiaomnichanneleva.cloudfunctions.net/iberia-pro-ibot-live-agent-connector",
    },
    allowOrigin: process.env.ALLOW_ORIGIN || "*"
}
